import React, { useState, useEffect } from 'react'
import Clothes from './Clothes.jsx'
import { useNavigate, useParams } from 'react-router-dom';
import '../styling/ProductDetail.css';
import logo from "../sources/H-logo.png";
import axios from 'axios';
import size from "../sources/size.png";
import athlete from "../sources/athlete.jpg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons';
import logo1 from "../sources/hnigg.png";
import i1 from "../sources/i1.jpg";
import i2 from "../sources/i2.jpg";
import i3 from "../sources/i3.jpg";
import i4 from "../sources/i4.jpg";
import i13 from "../sources/i13.png";
import i14 from "../sources/i14.png";
import i7 from "../sources/i7.png";
import i8 from "../sources/i8.png";

import r1 from "../sources/r1.jpg";
import r2 from "../sources/r2.jpg";
import r3 from "../sources/r3.jpg";
import r4 from "../sources/r4.jpg";
import r5 from "../sources/r5.jpg";
import r6 from "../sources/r6.jpg";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const [selectedSize, setSelectedSize] = useState('');
  const userID = localStorage.getItem('userID');
  const isLoggedIn = localStorage.getItem('isLoggedIn');
  const [popup, setPopup] = useState(false);
  const [logpopup, setlogPopup] = useState(false);
  const [loginpopup, setloginPopup] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const refresh = () => {
    navigate("/");
  }
  const cloth = Clothes.find((item) => item.id === parseInt(id));

  const tempid = localStorage.getItem("tempid");

  useEffect(() => {
    const tempid = localStorage.getItem("tempid");

    if (tempid && userID) {
      setlogPopup(true);
      localStorage.removeItem("tempid");

      setTimeout(() => {
        setlogPopup(false);
      }, 2000);
    }
  }, [userID]);

  const handleQuantityChange = async (id, action, size) => {
    try {

      if (!userID) {
        localStorage.setItem("tempid", id);
        alert('Please login to add items!')
        navigate('/login');
        return;
      }

      if (size === '' || !size) {
        alert('Enter valid size!')
        return;
      }

      setTimeout(() => {
        setPopup(false);
      }, 2000)


      setPopup(true);

      // console.log('Action: ', action);
      // console.log('id: ', id);
      // console.log('Size: ', size);

      if (action === "increase") {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/${userID}/add-item/${id}`, { size: size }, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        console.log(response.message);
      }
      else if (action === "decrease") {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/${userID}/remove-item/${id}`, { size: size }, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        console.log(response.message);
      }
    } catch (error) {
      console.log('Error: ', error);
      if (error.response && error.response.status === 401) {
        alert("Session expired. Please log in again.");
        localStorage.clear();
        navigate("/login");
      }
    }
  }

  const handleSize = async (size) => {
    try {
      if (isLoggedIn) {
        setSelectedSize(size);
      }
      if (!isLoggedIn) {
        alert("Please login to add items!");
        navigate("/login");
      }
    } catch (error) {
      console.log('Error: ', error);
    }
  }
  const handleLogout = async () => {
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("userID");
      localStorage.removeItem("tempid");
      localStorage.setItem("isLoggedIn", false);
      localStorage.removeItem("tempid");
      setloginPopup(true);

      setTimeout(() => {
        setloginPopup(false);
        window.location.reload();
      }, 1500);
      console.log('User logged out successfully.');
    } catch (error) {
      console.log('Error: ', error);
    }
  }

  const handleClick = (id) => {
    navigate(`/products/${id}`);
    window.scrollTo(0, 0);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE, and Opera
  };
  if (!cloth) {
    return (
      <>
        <h1 style={{ textAlign: "center" }}>Product not found.</h1>
      </>
    )
  }

  return (
    <>
      <div className='navbar not-fixed'>
        <p>WE THE INDEPENDENT</p>
      </div>
      {loginpopup && (
        <>
          <div className='notification-box'>
            <h3 className='blinking-text'>Logged out successfully!</h3>
          </div>
        </>
      )}
      {logpopup && (
        <>
          <div className='notification-box'>
            <h3 className='blinking-text'>Loggedin successfully!</h3>
          </div>
        </>
      )}
      {popup && (
        <>
          <div className='notification-box'>
            <h3 className='blinking-text'>Item added to cart!</h3>
          </div>
        </>
      )}
      <div className='main m1 black' >
        <img src={logo} alt="logo" className='logo' onClick={refresh} />
        <div className="dropdown db d1 black new-dropdown">
          <div className="hamburger-icon hi" onClick={() => setIsOpen(!isOpen)}>
            <span></span>
            <span></span>
            <span></span>
          </div>
          {isOpen && (
            <div className="dropdown-menu black new-dropdown-inside">
              {(isLoggedIn == "false" || (isLoggedIn == null)) && (
                <a onClick={() => navigate("/login")} className="dropdown-item">Login</a>
              )}
              <a onClick={() => navigate("/cart")} className="dropdown-item">Cart</a>
              <a onClick={() => navigate("/dashboard")} className="dropdown-item">My Orders</a>
              {(isLoggedIn == "true") && (
                <a onClick={handleLogout} className="dropdown-item">Logout</a>
              )}
            </div>
          )}
        </div>
      </div>
      <div className='pd'>

        <div className='img-div pd25'>
          <img src={cloth.imgURL} alt='item-img' />
          <img src={cloth.altURL} alt='item-img' />
        </div>
        <div className='flex-row pd25'>
          <div className='left-box inv-rev'>
            <h3>Product Details</h3>
            <h2>{cloth.name}</h2>
            <p>Experience ultimate comfort and style with our premium True Hood T-shirt. Crafted from 100% soft,
              breathable cotton. Whether you' re dressing up for a special occasion or keeping it casual, our
              True Hood T-shirt is the perfect choice for any wardrobe.</p>
            <p>Details: Product is of 220GSM Single Jersey(Oversized) with an {cloth.description} design on it.

            </p>
            <p>Material: 100% Bio Washed</p>
            <p>Color: {cloth.color}</p>
            <p>In case of a size issue, we recommend choosing a larger size for a better oversized feel.</p>

          </div>

          <div className='right-box'>
            <h3>Oversized {cloth.color} t-shirt</h3>
            <h2>{cloth.name}</h2>
            <p className='black'>₹{cloth.price}.00</p>
            <div className='boxes'>
              <div className='box' onClick={() => handleSize('S')}>S</div>
              <div className='box' onClick={() => handleSize('M')}>M</div>
              <div className='box' onClick={() => handleSize('L')}>L</div>
              <div className='box' onClick={() => handleSize('XL')}>XL</div>
              <div className='box' onClick={() => handleSize('XXL')}>XXL</div>
            </div>
            <h3><a href="#size">Size Guide</a></h3>
            <p>Selected Size: <b>{selectedSize}</b></p>
            <button className='atc' onClick={() => handleQuantityChange(cloth.id, 'increase', selectedSize)}>Add to Cart</button>
          </div>
        </div>

        <section id="middle">
          <h3>A journey to develop ground-breaking oversized apparel.</h3>
        </section>

        <section id="size" className='pd25'>
          <div className='flex-row fr1'>
            <div className='l-box'>
              <img src={size} alt="size.png" />
            </div>
            <div className='r-box'>
              <h3>Size Guide</h3>
              <h1 className='inv-rev'>Optimized for you</h1>
              <div className='pla'>
                <p className=''>True Hood apparel is crafted to embody the essence of urban culture, blending contemporary design with unmatched comfort. Each piece is tailored for a relaxed fit, allowing effortless movement while showcasing bold, authentic statements. With True Hood, you don’t just wear fashion—you represent a lifestyle that celebrates individuality, resilience, and the fearless pursuit of self-expression.</p>
              </div>
              <p>
                <div className='bold inv-rev'>
                  <b>If you fall between sizes, for maximum performance benefits we advise selecting the smaller size.</b>
                </div>
              </p>


              <div className='size-table-container'>
                <table className='size-table'>
                  <thead>
                    <tr>
                      <th></th>
                      <th>S</th>
                      <th>M</th>
                      <th>L</th>
                      <th>XL</th>
                      <th>XXL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div>CHEST (IN)</div>
                        <div>(A in fig)</div>
                      </td>
                      <td>41</td>
                      <td>43</td>
                      <td>45</td>
                      <td>47</td>
                      <td>49</td>
                    </tr>

                    <tr>
                      <td>
                        <div>Length (IN)</div>
                      </td>
                      <td>26</td>
                      <td>27</td>
                      <td>28</td>
                      <td>29</td>
                      <td>30</td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>

            <div className='mb-visible'>
              <h3>Product details</h3>
              <div className='size-table-container'>
                <table className='size-table'>
                  <tbody>
                    <tr>
                      <td>GSM</td>
                      <td><span className='highlight'>220GSM</span> (Oversized)</td>
                    </tr>
                    <tr>
                      <td>Design Size</td>
                      <td>{cloth.description}</td>
                    </tr>
                    <tr>
                      <td>Fabric</td>
                      <td>Single Jersey</td>
                    </tr>
                    <tr>
                      <td>Material</td>
                      <td><span className='highlight'>100% Bio Washed</span></td>
                    </tr>
                    <tr>
                      <td>Color</td>
                      <td><span className='highlight'>{cloth.color}</span></td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <em>In case of a size issue, we recommend choosing a larger size for a better oversized feel.</em>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>


            </div>
          </div>
        </section>

        {/* <section id='home-div'>
          <h1 className='ymal'>You may also like</h1>
          <div className='flex-row hr fr1'>
            <div className='flex-col hc' onClick={() => handleClick(1)}>
              <img src={i1} className="body-img-top" alt="T-Shirt Green" />
              <img src={i2} className="body-img-hover" alt="T-Shirt Green Hover" />
              <div className="body-body">
                <p className='gray-text'>OVERSIZED T-SHIRT</p>
                <h5 className="body-title">Vengeance of the Hood</h5>
                <p className="body-text"> ₹699.00</p>
              </div>
            </div>

            <div className='flex-col hc' onClick={() => handleClick(3)}>
              <img src={i3} className="body-img-top" alt="T-Shirt Green" />
              <img src={i4} className="body-img-hover" alt="T-Shirt Green Hover" />
              <div className="body-body">
                <p className='gray-text'>OVERSIZED T-SHIRT</p>
                <h5 className="body-title">True Hood Original</h5>
                <p className="body-text"> ₹599.00</p>
              </div>
            </div>

            <div className='flex-col hc' onClick={() => handleClick(13)}>
              <img src={i13} className="body-img-top" alt="T-Shirt Green" />
              <img src={i14} className="body-img-hover" alt="T-Shirt Green Hover" />
              <div className="body-body">
                <p className='gray-text'>OVERSIZED T-SHIRT</p>
                <h5 className="body-title">Hood Over Fear</h5>
                <p className="body-text"> ₹699.00</p>
              </div>
            </div>

            <div className='flex-col hc' onClick={() => handleClick(7)}>
              <img src={i7} className="body-img-top" alt="T-Shirt Green" />
              <img src={i8} className="body-img-hover" alt="T-Shirt Green Hover" />
              <div className="body-body">
                <p className='gray-text'>OVERSIZED T-SHIRT</p>
                <h5 className="body-title">The Black Panther Tee</h5>
                <p className="body-text"> ₹799.00</p>
              </div>
            </div>
          </div>
        </section> */}

        <section id='more-about'>
          <h1>Reviews by our customers</h1>
          <div className='more-container'>
            <div className='more'>

              <div className='each-review'>
                <img src={r4} alt='review.png' />
                <p>Nice tee, but needed more colors. (Mans)</p>
              </div>

              <div className='each-review'>
                <img src={r2} alt='review.png' />
                <p>Perfect fit and super comfy all day. (Hruday)</p>
              </div>

              <div className='each-review'>
                <img src={r6} alt='review.png' />
                <p>vibin' in our fav vacation fit. (Poojyanth)</p>
              </div>

              <div className='each-review'>
                <img src={r5} alt='review.png' />
                <p>Liked the design, really unique! (Rushindra)</p>
              </div>

              <div className='each-review'>
                <img src={r1} alt='review.png' />
                <p>This tee really matches my vibe! (Arjit)</p>
              </div>

              <div className='each-review'>
                <img src={r3} alt='review.png' />
                <p>T-shirt quality was top-notch, loved it. (Vivek)</p>
              </div>


              {/* Duplicate set for seamless loop */}
              <div className='each-review'>
                <img src={r4} alt='review.png' />
                <p>Nice tee, but needed more colors. (Mans)</p>
              </div>

              <div className='each-review'>
                <img src={r2} alt='review.png' />
                <p>Perfect fit and super comfy all day. (Hruday)</p>
              </div>

              <div className='each-review'>
                <img src={r6} alt='review.png' />
                <p>vibin' in our fav vacation fit. (Poojyanth)</p>
              </div>

              <div className='each-review'>
                <img src={r5} alt='review.png' />
                <p>Liked the design, really unique! (Rushindra)</p>
              </div>

              <div className='each-review'>
                <img src={r1} alt='review.png' />
                <p>This tee really matches my vibe! (Arjit)</p>
              </div>

              <div className='each-review'>
                <img src={r3} alt='review.png' />
                <p>T-shirt quality was top-notch, loved it. (Vivek)</p>
              </div>

            </div>
          </div>
        </section>

        <section id='footer' className='priv new-priv'>
          <div className='mp'>
            <img src={logo1} alt="logo.png" />
            <div className='move-p'>
              <p className='inv-rev'>Born in the hood and praised on the street,<br />
                True Hood has firmly settled itself as an iconic<br />
                street wear brand inspired by innovation and style.</p>
            </div>
          </div>
          <div className='mp1'>
            <h4>Customer</h4>
            <a onClick={() => navigate("/customer-care")}>FAQ</a>
            <a onClick={() => navigate("/dashboard")}>My Orders</a>
            <a onClick={() => navigate("/customer-care")}>Contact Us</a>
            <a onClick={() => navigate("/rp")}>Returns</a>
          </div>
          <div className='mp1'>
            <h4>Navigate</h4>
            <a onClick={() => navigate("/login")}>Login</a>
            <a onClick={() => navigate("/tac")}>Terms & Conditions</a>
            <a onClick={() => navigate("/rp")}>Refund Policy</a>
            <a onClick={() => navigate("/register")}>Register</a>
          </div>
          <div className='mp1'>
            <h4>Follow us at</h4>
            <div className='flex-row'>
              <a href="https://mail.google.com/mail/?view=cm&fs=1&to=truehood.business@gmail.com" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faEnvelope} />
              </a>
              <a href="https://www.instagram.com/truehoodclothing" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a href="https://www.facebook.com/profile.php?id=61578190333707" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faFacebook} />
              </a>
            </div>
          </div>


        </section>
        <div className='copyright'>
          <h3>© Copyright 2025 True Hood</h3>
        </div>
      </div>
    </>
  )
}

export default ProductDetail